<div class="transactions-table-container">
  <app-pending-transactions-carousel></app-pending-transactions-carousel>
  <form class="table-controls-container" [formGroup]="transactionsControlsForm">
    <div class="header-container">
      <div class="text-title-2">Transactions</div>
      <app-dropdown formControlName="periodId"
                    [placeholder]="'Period...'"
                    [isOptionObject]="true"
                    [transparent]="true"
                    (chosenOption)="fetchFirstPage()"
                    [options]="periodsList"
                    [isLoading]="isLoading$ | async"
      ></app-dropdown>
    </div>

    <div class="table-controls" [class.locations]="inventoryLocationsEnabled$ | async">
      <app-input-search-scanner formControlName="searchValue"
                                [isInventory]="true"
                                [hideDropdown]="true"
                                [color]="SearchInputColorEnum.Green"
                                (optionSelected)="optionSelected($event)"
                                (searchCleared)="searchCleared()"
                                (searchValueChanged)="searchChanged()"
                                [placeholder]="'Search by drug name, NDC, Rx # or patient name'"
                                [hasError]="transactionsControlsForm.get('searchValue')?.value && (transactions$ | async)?.length === 0"
      ></app-input-search-scanner>

      <app-dropdown formControlName="activityType"
                    class="activity"
                    (chosenOption)="fetchFirstPage()"
                    [options]="activityTypesList"
                    [isOptionObject]="true"
                    [isLoading]="isLoading$ | async"
                    [placeholder]="'All Actions'"
      ></app-dropdown>

      <app-schedules-filter *ngIf="enableC3toC5Drugs$ | async"
        class="schedules"
        [control]="transactionsControlsForm.controls.schedules">
      </app-schedules-filter>

      <app-dropdown formControlName="createById"
                    class="users"
                    (chosenOption)="fetchFirstPage()"
                    [options]="usersList"
                    [isOptionObject]="true"
                    [isLoading]="isLoading$ | async"
                    [placeholder]="'All Users'"
      ></app-dropdown>

      <app-inventory-locations-filter *ngIf="inventoryLocationsEnabled$ | async"
        class="ml-4"
        [control]="transactionsControlsForm.controls.inventoryLocations">
      </app-inventory-locations-filter>
    </div>
  </form>
<ng-container *ngIf="(transactions$ | async) as transactions">
  <div *ngIf="transactions?.length > 0" class="table-scroll-wrapper main-scroll-default">
    <table class="table-primary">
      <thead>
        <tr>
          <th (click)="sortByColumn(OrderByEnum.TransactionDate)" class="text-left sort recorded" scope="col">
            DATE/TIME
            <img [class.asc]="tableColumns.transactionDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
              alt="asc" />
          </th>
          <th class="text-left info" scope="col">
            Info
          </th>
          <th (click)="sortByColumn(OrderByEnum.FriendlyName)" class="text-left sort drug" scope="col">
            Drug
            <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
              alt="asc" />
          </th>
          <th (click)="sortByColumn(OrderByEnum.ActivityType)" class="text-left sort activity" scope="col">
            Activity
            <img [class.asc]="tableColumns.activityType" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
              alt="asc" />
          </th>
          <th *ngIf="inventoryLocationsEnabled$ | async"
            (click)="sortByColumn(OrderByEnum.ActivityType)" class="text-left location !pl-[14px]" scope="col">
            Location
            <img [class.asc]="tableColumns.activityType" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
              alt="asc" />
          </th>
          <th (click)="sortByColumn(OrderByEnum.StartingQuantity)" class="text-right sort starting whitespace-nowrap" scope="col">
            Starting
            <img [class.asc]="tableColumns.startingQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
              alt="asc" />
          </th>
          <th (click)="sortByColumn(OrderByEnum.AddedQuantity)" class="text-right sort count whitespace-nowrap" scope="col">
            Count
            <img [class.asc]="tableColumns.addedQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
              alt="asc" />
          </th>
          <th (click)="sortByColumn(OrderByEnum.EndingQuantity)" class="text-right sort on-hand whitespace-nowrap" scope="col">
            On-Hand
            <img [class.asc]="tableColumns.endingQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
              alt="asc" />
          </th>
        </tr>
      </thead>
      <tbody
        [ngClass]="dashboardWithCarousel ? 'dashboard-with-carousel-table-body-height' : 'dashboard-table-body-height'"
        infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
        [scrollWindow]="false" (scrolled)="onScrollDown()" #tbody>

        <tr class="table-row" (click)="openSideWidget(rowData)" *ngFor="let rowData of transactions"
          [title]="(environment.production ? '' : 'transactions-table: ' + rowData.id)">
          <th class="text-left recorded" scope="row">
            <div class="heading">
              {{rowData.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
            </div>
            <div class="secondary">
              {{rowData.firstName}} {{rowData.lastName[0]}}.
            </div>
          </th>
          <th class="text-left info">
            <div class="heading" [auditOrderRedirectLinkClass] [activityType]="rowData.activityType"
              (click)="openAuditOrOrder(rowData)">
              {{rowData?.infoHeading}}
            </div>
            <div class="secondary">
              {{rowData?.infoSecondary}}
            </div>
            <div *ngIf="rowData?.infoSecondary2"
              class="secondary"
            >
              {{rowData.infoSecondary2}}
            </div>
          </th>
          <td class="text-left drug">
            <div class="heading">
              {{rowData.friendlyName}}
            </div>
            <div class="secondary">
              {{rowData.packageNdc}}
            </div>
          </td>
          <td class="text-left activity">
            <app-badge [color]="(rowData | transactionBadge)?.color">
              {{(rowData | transactionBadge)?.label}}
            </app-badge>
          </td>
          <td *ngIf="inventoryLocationsEnabled$ | async" class="location text-left">{{rowData?.locationName}}</td>
          <td class="text-right starting">{{rowData.startingQuantity | number}}</td>
          <td class="text-right count">{{rowData.addedQuantity | number}}</td>
          <td class="text-right on-hand">{{rowData.endingQuantity | number}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
<div *ngIf="(isLoading$ | async) !== true && !transactionsControlsForm.get('searchValue')?.value && (transactions$ | async)?.length === 0"
       class="empty-table-splash"
  >
    <div class="splash-container">
      <div class="icon-container">
        <img class="splash-icon" src="assets/icons/icon-transactions-empty.svg" alt="empty-transactions-table-icon" />
      </div>

      <div class="label">There are no items to display</div>
    </div>
  </div>

  <app-search-empty-splash *ngIf="(isLoading$ | async) !== true && transactionsControlsForm.get('searchValue')?.value && (transactions$ | async)?.length === 0"
                           [searchValue]="transactionsControlsForm.get('searchValue')?.value"
  ></app-search-empty-splash>
</div>

<app-amend-dialog *ngIf="showAmendingDialog"
  [show]="true"
  (cancel)="cancelAmend()"
  (amend)="amended($event)"
  [transaction]="transactionToAmend"
></app-amend-dialog>


<app-enter-pin-dialog #pinUser
                      [focusPin]="focusPin"
                      [show]="showPinDialog"
                      (cancel)="closePinDialog()"
                      (setPinHandler)="afterPinHandled($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-enter-pin-dialog #pinWitness
                      [focusPin]="focusPin"
                      [show]="showWitnessPinDialog"
                      [isWitness]="true"
                      (cancel)="closeWitnessPinDialog()"
                      (setPinHandler)="afterWitnessPinHandled($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog [show]="showResetPinDialog"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>
